import { useMemo } from 'react';
import { useTranslation } from 'next-i18next';

export const useAboutUsCMSData = () => {
  const { t } = useTranslation('');

  const data = useMemo(
    () => ({
      data: {
        AboutUsPage: {
          patternBackgroundSmall: {
            alt: 'Asphalt background',
            url: '/imgs/Rebranding/petterns/asphalt_sm.png',
          },
          patternBackgroundLarge: {
            alt: 'Asphalt background',
            url: '/imgs/Rebranding/petterns/asphalt.png',
          },
          heroPageTitle: t('about_us_page:page_title'),
          heroHeadingFirst: t('about_us_page:hero_heading_first'),
          heroHeadingSecond: t('about_us_page:hero_heading_second'),
          heroFirstParagraph: t('about_us_page:hero_first_paragraph'),
          heroSecondParagraph: t('about_us_page:hero_second_paragraph'),
          heroImageSmall: {
            alt: 'eaglerider hero image',
            url: '/imgs/Rebranding/About/about-hero-sm.jpg',
          },
          heroImageMedium: {
            alt: 'eaglerider hero image',
            url: '/imgs/Rebranding/About/about-hero-md.jpg',
          },
          heroImageLarge: {
            alt: 'eaglerider hero image',
            url: '/imgs/Rebranding/About/about-hero-lg.jpg',
          },
          heroImageXlarge: {
            alt: 'eaglerider hero image',
            url: '/imgs/Rebranding/About/about-hero-xl.jpg',
          },
          experienceHeading: t('about_us_page:experience_heading'),
          experienceParagraph: t('about_us_page:experience_paragraph'),
          experienceBackgroundImageSmall: {
            alt: 'eaglerider experience image',
            url: '/imgs/Rebranding/About/about-experience-sm.jpg',
          },
          experienceBackgroundImageMedium: {
            alt: 'eaglerider experience image',
            url: '/imgs/Rebranding/About/about-experience-md.jpg',
          },
          experienceBackgroundImageLarge: {
            alt: 'eaglerider experience image',
            url: '/imgs/Rebranding/About/about-experience-lg.jpg',
          },
          experienceBackgroundImageXlarge: {
            alt: 'eaglerider experience image',
            url: '/imgs/Rebranding/About/about-experience-xl.jpg',
          },
          leadershipHeadingFirst: t('about_us_page:leadership_heading_first'),
          leadershipFirstParagraph: t('about_us_page:leadership_first_paragraph'),
          leadershipSecondParagraph: t('about_us_page:leadership_second_paragraph'),
          leadershipSignature: t('about_us_page:leadership_signature'),
          leadershipImageSmall: {
            alt: 'eaglerider CEO image',
            url: '/imgs/Rebranding/About/about-leadership-sm.jpg',
          },
          leadershipImageMedium: {
            alt: 'eaglerider CEO image',
            url: '/imgs/Rebranding/About/about-leadership-md.jpg',
          },
          leadershipImageLarge: {
            alt: 'eaglerider CEO image',
            url: '/imgs/Rebranding/About/about-leadership-lg.jpg',
          },
          leadershipImageXlarge: {
            alt: 'eaglerider CEO image',
            url: '/imgs/Rebranding/About/about-leadership-xl.jpg',
          },
          futureHeading: t('about_us_page:future_heading'),
          futureExpansionParagraph: t('about_us_page:future_expansion_paragraph'),
          futureBackgroundImageSmall: {
            alt: 'eaglerider future image',
            url: '/imgs/Rebranding/About/about-future-sm.jpg',
          },
          futureBackgroundImageMedium: {
            alt: 'eaglerider future image',
            url: '/imgs/Rebranding/About/about-future-md.jpg',
          },
          futureBackgroundImageLarge: {
            alt: 'eaglerider future image',
            url: '/imgs/Rebranding/About/about-future-lg.jpg',
          },
          futureBackgroundImageXlarge: {
            alt: 'eaglerider future image',
            url: '/imgs/Rebranding/About/about-future-xl.jpg',
          },
          bannerHeadingFirst: t('about_us_page:banner_heading_first'),
          bannerHeadingSecond: t('about_us_page:banner_heading_second'),
          bannerBackgroundImageSmall: {
            alt: 'eaglerider banner image',
            url: '/imgs/Rebranding/About/about-banner-sm.jpg',
          },
          bannerBackgroundImageMedium: {
            alt: 'eaglerider banner image',
            url: '/imgs/Rebranding/About/about-banner-md.jpg',
          },
          bannerBackgroundImageLarge: {
            alt: 'eaglerider banner image',
            url: '/imgs/Rebranding/About/about-banner-lg.jpg',
          },
          bannerBackgroundImageXlarge: {
            alt: 'eaglerider banner image',
            url: '/imgs/Rebranding/About/about-banner-xl.jpg',
          },
          patternBackground: {
            small_url: {
              alt: 'Asphalt background',
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            medium_url: {
              alt: 'Asphalt background',
              url: '/imgs/Rebranding/petterns/asphalt_sm.png',
            },
            large_url: {
              alt: 'Asphalt background',
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            xlarge_url: {
              alt: 'Asphalt background',
              url: '/imgs/Rebranding/petterns/asphalt.png',
            },
            alt: 'Asphalt background',
          },
          heroImage: {
            small_url: {
              alt: 'eaglerider hero image',
              url: '/imgs/Rebranding/About/about-hero-sm.jpg',
            },
            medium_url: {
              alt: 'eaglerider hero image',
              url: '/imgs/Rebranding/About/about-hero-md.jpg',
            },
            large_url: {
              alt: 'eaglerider hero image',
              url: '/imgs/Rebranding/About/about-hero-lg.jpg',
            },
            xlarge_url: {
              alt: 'eaglerider hero image',
              url: '/imgs/Rebranding/About/about-hero-xl.jpg',
            },
            alt: 'eaglerider hero image',
          },
          experienceBackgroundImage: {
            small_url: {
              alt: 'eaglerider experience image',
              url: '/imgs/Rebranding/About/about-experience-sm.jpg',
            },
            medium_url: {
              alt: 'eaglerider experience image',
              url: '/imgs/Rebranding/About/about-experience-md.jpg',
            },
            large_url: {
              alt: 'eaglerider experience image',
              url: '/imgs/Rebranding/About/about-experience-lg.jpg',
            },
            xlarge_url: {
              alt: 'eaglerider experience image',
              url: '/imgs/Rebranding/About/about-experience-xl.jpg',
            },
            alt: 'eaglerider experience image',
          },
          leadershipImage: {
            small_url: {
              alt: 'eaglerider CEO image',
              url: '/imgs/Rebranding/About/about-leadership-sm.jpg',
            },
            medium_url: {
              alt: 'eaglerider CEO image',
              url: '/imgs/Rebranding/About/about-leadership-md.jpg',
            },
            large_url: {
              alt: 'eaglerider CEO image',
              url: '/imgs/Rebranding/About/about-leadership-lg.jpg',
            },
            xlarge_url: {
              alt: 'eaglerider CEO image',
              url: '/imgs/Rebranding/About/about-leadership-xl.jpg',
            },
            alt: 'eaglerider CEO image',
          },
          futureBackgroundImage: {
            small_url: {
              alt: 'eaglerider future image',
              url: '/imgs/Rebranding/About/about-future-sm.jpg',
            },
            medium_url: {
              alt: 'eaglerider future image',
              url: '/imgs/Rebranding/About/about-future-md.jpg',
            },
            large_url: {
              alt: 'eaglerider future image',
              url: '/imgs/Rebranding/About/about-future-lg.jpg',
            },
            xlarge_url: {
              alt: 'eaglerider future image',
              url: '/imgs/Rebranding/About/about-future-xl.jpg',
            },
            alt: 'eaglerider future image',
          },
          bannerBackgroundImage: {
            small_url: {
              alt: 'eaglerider banner image',
              url: '/imgs/Rebranding/About/about-banner-sm.jpg',
            },
            medium_url: {
              alt: 'eaglerider banner image',
              url: '/imgs/Rebranding/About/about-banner-md.jpg',
            },
            large_url: {
              alt: 'eaglerider banner image',
              url: '/imgs/Rebranding/About/about-banner-lg.jpg',
            },
            xlarge_url: {
              alt: 'eaglerider banner image',
              url: '/imgs/Rebranding/About/about-banner-xl.jpg',
            },
            alt: 'eaglerider banner image',
          },
        },
      },
    }),
    [t],
  );

  return data;
};
